// export { default as PerformanceTable } from './Table';
// export { default as Column } from './Column';
// export { default as Cell } from './Cell';
// export { default as HeaderCell } from './HeaderCell';
// export { default as ColumnGroup } from './ColumnGroup';
import PerformanceTable from './Table';
export default PerformanceTable;
